import { Controller } from "@hotwired/stimulus"

// "Mask project as a user" (Phelipe 2026-10-10): the search over the pop-up's
// companies, shown once the list is long (a bidding project's bidders). Every
// word has to be in the company or its role, accents and capitals ignored; a
// role's heading hides when none of its companies match. Opening and closing
// is the shared modal controller's job.
const fold = (s) => String(s ?? "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()

export default class extends Controller {
  static targets = ["search", "row", "group", "none"]
  static values = { none: String }

  filter() {
    const q = this.hasSearchTarget ? this.searchTarget.value : ""
    const words = fold(q).split(/\s+/).filter(Boolean)
    let shown = 0
    this.rowTargets.forEach((row) => {
      const ok = !words.length || words.every((w) => fold(row.dataset.searchText).includes(w))
      row.style.display = ok ? "" : "none"
      if (ok) shown++
    })
    this.groupTargets.forEach((group) => {
      const any = this.rowTargets.some((row) => group.contains(row) && row.style.display !== "none")
      group.style.display = any ? "" : "none"
    })
    if (this.hasNoneTarget) {
      this.noneTarget.textContent = this.noneValue.replace("%{q}", q.trim())
      this.noneTarget.classList.toggle("hidden", !(words.length && !shown))
    }
  }

  // Enter in the search box filters; it never starts the mask.
  keep(e) {
    e.preventDefault()
  }
}
